import React from 'react';

import { useNavbar } from '../hooks/useNavbar';

import Dropdown from './Dropdown';
import SubNavlink from './SubNavlink';
import Button from './Button';

export default function Navlink({ navlink }) {
  const { subButtons } = navlink;
  const { onClickSubNavlink, isActiveSubNavlink, isActiveNavLink } =
    useNavbar();
  const SubNavlinks = ({ subNavlinks }) => (
    <>
      {subNavlinks?.map((subNavlink) => (
        <Button
          key={subNavlink.id}
          button={{
            ...subNavlink,
            version: 'tertiary-text',
            iconPosition: 'left',
            additionalClassNames: `--light ${
              subNavlink.icon ? '--icon-absolute-left' : ''
            }`
          }}
          onClick={() => onClickSubNavlink(subNavlink)}
          isDisabled={isActiveSubNavlink(subNavlink)}
          isActive={isActiveSubNavlink(subNavlink)}
        >
          <SubNavlink subNavlink={subNavlink} />
        </Button>
      ))}
    </>
  );

  return (
    <li className="navlink" key={navlink?.id}>
      {navlink.subButtons && (
        <Dropdown
          columns="2"
          button={{ ...navlink, isActive: isActiveNavLink(navlink) }}
        >
          <SubNavlinks subNavlinks={subButtons} />
        </Dropdown>
      )}
    </li>
  );
}
